import ArrowUp from 'assets/icons/ios/ios-arrow-up.svg'

ArrowUp.displayName = 'ArrowUp'
export default ArrowUp
